import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { RateMovieComponent } from '../dialog/new-post/rate-movie/rate-movie.component';
import { Location } from '@angular/common';

import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-movie-info',
  templateUrl: './movie-info.component.html',
  styleUrls: ['./movie-info.component.css'],
})
export class MovieInfoComponent implements OnInit {
  router: any;
  public Comments: any = [];
  today: number = Date.now();
  Url: string;
  shareUrl: string;
  type: 'facebook' | 'twitter';
  constructor(
    public ShowcasesService: ShowcaseService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private spotlightService: SpotlightService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private _location: Location,
    private routerurl: Router
  ) {
    this.id = route.snapshot.params.id;
  }

  data: any = { sourceType: 'url', url: 'https://twitter.com/Creatics2' };
  movie: any = [];
  GiveRate: string;
  Shorts: any = [];
  starCast: any = [];
  name: any;
  showSideBar: boolean = false;
  ShortDescriptive1: any = [];
  description: any = [];
  country: any = [];
  movieList: any = [];
  rating: number;
  language: string;
  duration: any;
  tags: any = [];
  categories: any = [];
  subCategories: any = [];
  id: any;
  public errorApi = true;
  result = [];
  dates: any;
  subCat: any = [];
  backArrow = "assets/images/cinejoy/arrow-left.png";
  officialLogo = "assets/images/spotlight/Laurel.svg"
  trailerUrl: any;
  spotlightMovies: any = [];
  counter = 0;
  isSecondarySideNavOpen: boolean;
  screeningPartyList: any = [];
  splContent: any;
  splContent1: any;
  isUserLoggedIn: boolean;
  ngOnInit(): void {
    this.getShowcaseList();
    (<any>window).twttr.widgets.load();

  }


  getShowcaseList() {
    this.ShowcasesService.getMovieById(this.id).subscribe((res) => {
      this.movie = res;
      let url = `https://player.vimeo.com/video/${this.movie.trailer}?quality=1080p`;
      let url1 = `https://player.vimeo.com/video/${this.movie.video1}?quality=1080p`;
      let url2 = `https://player.vimeo.com/video/${this.movie.video2}?quality=1080p`
      this.trailerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.splContent = this.sanitizer.bypassSecurityTrustResourceUrl(url1);
      this.splContent1 = this.sanitizer.bypassSecurityTrustResourceUrl(url2);
      if (this.movie.user > 0) {
        this.getSpotlightPremierList();
        this.getScreeningPartyList();
      }
      this.id = res.id;
      this.errorApi =
        res.moviesArray == null ||
        res.moviesArray === 0 ||
        res.moviesArray.length === 0;
    });

  }

  openDialogRateMovie() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { movieId: this.id, moveDetails: this.movie }
    let movieId = this.id
    this.dialog.open(RateMovieComponent, dialogConfig).afterClosed().subscribe((res) => {
      this.id = this.movie.eventId
      this.getShowcaseList()
    });;
  }

  openSideBar() {
    this.showSideBar = !this.showSideBar;

  }

  open(Id: number, movieList: any, purchaseStage: string): void {
    const modalRef = this.modalService.open(PurchaseFlowComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.eventId = Id;
    modalRef.componentInstance.premiere = movieList;
    modalRef.componentInstance.purchaseStage = purchaseStage;
  }

  goAll() {
    document.getElementById('targetAll').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  goAllScrollMobile() {
    document.getElementById('targetAllmobile').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
  navigateToScreeningParty() {

    this.routerurl.navigateByUrl(`/cinejoy/screening-parties/join`)
  }
  backClicked() {
    this._location.back();
  }

  getSpotlightPremierList() {
    this.spotlightService.getData().subscribe((res) => {
      this.spotlightMovies = res;
    })
  }

  navigateToSpolightEvent(movie) {
    let name = movie.name.replace(/ /g, '-');
    this.routerurl.navigateByUrl(`/cinejoy/premiere/more-info/${movie.eventId}/${name}`)
  }

  checkSpotlightEvent(movie) {
    let item = this.spotlightMovies.filter((v) => v.eventId == movie.eventId)
    if (item.length) {
      return true;
    } else {
      return false;
    }
  }

  getmovieName(moviename) {
    let name = moviename.replace(/ /g, '-');
    return name;
  }

  getScreeningPartyList() {
    this.spotlightService.getScreeningPartyList().subscribe((res) => {
      this.screeningPartyList = res;
    }, (err) => {
      console.log(err)
    })
  }

  checkScreeningPartyEvent(movie) {
    let item = this.screeningPartyList.filter((v) => v.cinejoyFeaturedMovie == movie.eventId)
    if (item.length) {
      return true;
    } else {
      return false;
    }
  }

  navigateToScreeningPartyEvent(movie) {
    let name = movie.name.replace(/ /g, '-');
  }

  shareButton(type) {
    let searchParams = new URLSearchParams();
    let url;
    switch (type) {
      case 'facebook':
        searchParams.set('u', this.movie.legacyPurchaseLink);
        searchParams.set('title', this.movie.name);
        searchParams.set('text', this.movie.description);

        url = 'https://www.facebook.com/sharer/sharer?' + searchParams;
        break;
      case 'twitter':
        searchParams.set('url', environment.apiURL + `create/cinejoy/showcase/moviepage/${this.movie.eventId}/${this.getmovieName(this.movie.name)}`);
        searchParams.set('title', this.movie.name);
        searchParams.set('text', this.movie.description);
        url = 'https://twitter.com/share?' + searchParams;
        break;
    }
    this.share(url)
  }

  share(url) {
    return window.open(
      url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=300,width=700,height=700'
    );
  }

  onLoad(event){}
}
